import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CoreConfig } from '@app/core/plugin';
import { ScheduleService } from '@app/core/services';
import { PortalUtils } from '@app/core/utils/portal.utils';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuBarComponent {
  @Input() public data: any;

  public config$: Observable<CoreConfig>;
  public showMenu = false;

  constructor(
    public dialog: MatDialog,
    public scheduleService: ScheduleService,
  ) {}

  public onSchedule() {
    this.onCloseMenu();
    return this.scheduleService.schedulingOnline();
  }

  public onToogle(event: any) {
    event.stopPropagation();
    this.showMenu = !this.showMenu;
  }

  public onCloseMenu() {
    this.showMenu = false;
  }

  public legend(data: any): string {
    return PortalUtils.legend(data);
  }
}
